export default __webpack_public_path__ + "static/media/steak-background.958e2a4d.jpg";